/**
 * Renders share candidates and identities consistently inside grant workflows.
 *
 * Users and groups remain distinct authorization subjects even when labels look
 * similar. Central candidate presentation reduces the risk that a display name
 * is mistaken for the identity receiving access.
 */
import { Check } from 'lucide-react'

import { cn } from '@/components/ui'
import { avatarColor } from '../lib/format'


export function VaultAvatar({
  userId,
  className,
}: {
  userId: string
  className?: string
}) {
  return (
    <span
      className={cn(
        'flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold uppercase ring-2 ring-background',
        avatarColor(userId),
        className,
      )}
    >
      {userId.slice(0, 2)}
    </span>
  )
}

export function ShareCandidateGroup({
  label,
  members,
  onSelect,
}: {
  label: string
  members: string[]
  onSelect: (userId: string) => void
}) {
  if (!members.length) return null
  return (
    <div>
      <p className="bg-muted/50 px-3 py-1.5 text-xs font-medium text-muted-foreground">
        {label}
      </p>
      {members.slice(0, 6).map(member => (
        <button
          key={member}
          type="button"
          className="flex w-full items-center gap-2 px-3 py-2 text-sm transition-colors hover:bg-muted"
          onClick={() => onSelect(member)}
        >
          <VaultAvatar userId={member} className="h-6 w-6 text-[10px]" />
          <span className="flex-1 truncate text-left">{member}</span>
          <Check className="h-4 w-4 text-muted-foreground" />
        </button>
      ))}
    </div>
  )
}
